import { css, html, LitElement } from 'lit-element';
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import '@material/mwc-radio';
import '@material/mwc-formfield';
import debounce from '@giswebgroup/ki-wcp-base/src/decorators/debounce';
import nls from '../../locales/index.nls';

export default
@i18n(nls)
class KiStationListHeader extends LitElement {
  // language=CSS
  static styles = css`
    :host {
      height: 100%;
      line-height: 40px;
      padding-left: 20px;
    }

    .header-icon {
      color: gray;
    }
    .header-icon:hover {
      color: var(--theme-color, #0056a0);
      cursor: pointer;
    }
    .header-label:hover {
      color: var(--theme-color, #0056a0);
      cursor: pointer;
    }
    .name-popup {
      color: gray;
      padding: 10px;
    }
    .name-popup.hidden {
      display: none;
    }
    .name-popup:hover {
      cursor: pointer;
      color: var(--theme-color, #0056a0);
    }
    .expand-icon {
      float: right;
      margin-right: 10px;
      padding: 12px 15px;
    }
    .expand-icon:hover {
      cursor: pointer;
      color: var(--theme-color, #0056a0);
    }

    mwc-formfield {
      display: block;
      white-space: nowrap;
    }

    mwc-radio {
      --mdc-theme-secondary: var(--theme-color, #0056a0);
    }
  `;

  static get properties() {
    return {
      label: { type: String },
      icon: { type: String },
      expand: { type: Boolean },
      stationLabelTemplate: { type: String },
      stationLabelFormats: { type: Array },
      hideFormatter: { type: Boolean },
    };
  }

  constructor() {
    super();
    this.expand = false;
    this.hideFormatter = false;
    this.stationLabelFormats = [
      {
        label: `${this.i18n.t('station_no')} | ${this.i18n.t('station_name')} | ${this.i18n.t('river_name')}`,
        value: '${station_no} | ${station_name} | ${river_name}', // eslint-disable-line
      },
      {
        label: `${this.i18n.t('station_no')} | ${this.i18n.t('river_name')} | ${this.i18n.t('station_name')}`,
        value: '${station_no} | ${river_name} | ${station_name}', // eslint-disable-line
      },
      {
        label: `${this.i18n.t('station_name')} | ${this.i18n.t('station_no')} | ${this.i18n.t('river_name')}`,
        value: '${station_name} | ${station_no} | ${river_name}', // eslint-disable-line
      },
      {
        label: `${this.i18n.t('station_name')} | ${this.i18n.t('river_name')} | ${this.i18n.t('station_no')}`,
        value: '${station_name} | ${river_name} | ${station_no} ', // eslint-disable-line
      },
      {
        label: `${this.i18n.t('river_name')} | ${this.i18n.t('station_no')} | ${this.i18n.t('station_name')}`,
        value: '${river_name} | ${station_no} | ${station_name}', // eslint-disable-line
      },
      {
        label: `${this.i18n.t('river_name')} | ${this.i18n.t('station_name')} | ${this.i18n.t('station_no')}`,
        value: '${river_name} | ${station_name} | ${station_no}', // eslint-disable-line
      },
    ];
    this.stationLabelTemplate = this.stationLabelFormats[0].value; // eslint-disable-line
  }

  render() {
    // language=html
    return html`
      <ki-icon class="header-icon" icon="${this.icon}"></ki-icon>
      <span class="header-label">${this.label}</span>
      <ki-icon class="name-popup ${this.hideFormatter ? 'hidden' : ''}" icon="ki ki-sort-v" id="popupBtn" @click="${this.togglePopup}"></ki-icon>
      <ki-popup for="popupBtn" left="100%" top="100%" id="popup">
        <div style="padding: 20px 30px 20px 20px">
          ${this.stationLabelFormats.map(labelFormat => {
            return html`
              <mwc-formfield label="${labelFormat.label}" id="form">
                <mwc-radio
                  name="group"
                  @click="${event => {
                    this._updateFormatter(event, labelFormat.value);
                  }}"
                  .checked="${this.stationLabelTemplate === labelFormat.value}"
                ></mwc-radio>
              </mwc-formfield>
            `;
          })}
        </div>
      </ki-popup>
      <paper-tooltip for="popupBtn">${this.i18n.t('sorting')}</paper-tooltip>
      <ki-icon
        class="expand-icon"
        icon="ki ${this.expand ? 'ki-chevron-up' : 'ki-chevron-down'}"
        @click="${() => {
          this.expand = !this.expand;
        }}"
      ></ki-icon>
    `;
  }

  togglePopup(event) {
    event.stopPropagation();
    const popup = this.renderRoot.querySelector('#popup');
    popup.visible = !popup.visible;
  }

  @debounce(2000)
  _closePopup() {
    const popup = this.renderRoot.querySelector('#popup');
    popup.visible = false;
  }

  _updateFormatter(event, formatter) {
    event.stopPropagation();
    this.dispatchEvent(
      new CustomEvent('updateFormat', {
        detail: { value: formatter },
      }),
    );
    this._closePopup();
  }
}

customElements.define('ki-station-list-header', KiStationListHeader);
